<a href="#" class="btn create-sprite-about-button">Create Sprite</a>
